import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "910dc3d9-eb0b-4522-8485-9121b2724384",
  publicId: "21",
  name: "Assessment of Speech intelligibility (C50,D50,U50,STI)",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
